import {
  Cell,
  CellPosition,
  CellReference,
  CellsReferences,
  Sheet,
} from '../../types';
import { SheetManagementSet } from '../../types/sheet/draft';
import { addIndependencies, removeIndependencies } from './independencies';
import { extractFormulaAddresses } from '../address/formulaAddress';
import _ from 'lodash';
import { deleteCell } from '../cells/cellCRUD';

// #region clear dependencies
export async function clearDependencies(
  set: SheetManagementSet,
  depSheetId: string,
  cellsReferences: CellsReferences,
  cellRefs: CellReference,
  position: CellPosition,
  cellAddress: string
) {
  const deps = cellRefs.d;

  if (deps) {
    for (const { sid, addr: indepAddress } of deps) {
      // const indepSheetId = sid === SELF_SHEET_REF ? sheetId : sid;

      await removeIndependencies(
        set,
        depSheetId,
        cellAddress,
        sid,
        indepAddress
      );
    }

    delete cellRefs.d;
    if (_.isEmpty(cellRefs)) {
      deleteCell(cellsReferences, position);
    }
    // delete sheet.dependencies[cellAddress];
  }
}
// #endregion

// #region add dependencies
export async function addDependencies(
  set: SheetManagementSet,
  depSheetId: string,
  cellRefs: CellReference,
  cellAddress: string,
  formula: string
) {
  if (!cellRefs.d) cellRefs.d = [];

  const addresses = extractFormulaAddresses(formula, depSheetId);

  for (const { sheetId: indepSheetId, address } of addresses) {
    const addr = address.replaceAll('$', '');

    // {
    // const sheetId =
    //   indepSheetId === depSheetId ? SELF_SHEET_REF : indepSheetId;
    // }
    cellRefs.d.push({
      sid: indepSheetId,
      addr,
    });

    await addIndependencies(set, depSheetId, cellAddress, indepSheetId, addr);
  }
}
// #endregion
